import React from 'react';
import PropTypes from 'prop-types';
import { isString, isFunction } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

import { Root, Header, IconWrapper } from '../../styles/hotspots/hotspot';
import { useModalTriggerHandler } from '../../utils/hooks';
import { HotspotTypes } from '../../utils/types';

/**
 * Creates a Hotspot with following props
 * @param {number} pitch Number between -PI and PI, the vertical angle in radians
 * @param {number} yaw Number between -PI and PI, the horizontal angle in radians
 * @param {string} title Title of the content
 * @param {Object} faIcon FontAwesome Icon
 * @param {number} type HotspotTypes value. See `src/utils/types.jsx`
 * @param {Object} data The data for this Hotspot. Output from one of the functions in `src/utils/hotspot-data-generators.jsx`
 */
const GenericHotspot = React.forwardRef(({ children, pitch, yaw, title, faIcon=faInfoCircle, onClick, type=HotspotTypes.Generic, data={} }, ref) => {

	const defaultClickHandler = useModalTriggerHandler(data, type);

	return(
		<Root ref={ref} onClick={isFunction(onClick)? onClick : defaultClickHandler} >
			<Header>
				<IconWrapper>
					<FontAwesomeIcon icon={faIcon} />
				</IconWrapper>
				<p>{ (isString(children)? children : title) || 'Hello There!' }</p>
			</Header>
		</Root>
	);
});

GenericHotspot.propTypes = {
	pitch: PropTypes.number.isRequired,
	yaw: PropTypes.number.isRequired,
	title: PropTypes.string.isRequired,
	faIcon: PropTypes.object,
	data: PropTypes.object
}

export default GenericHotspot;